import { ArrowUpRight } from "lucide-react";

const LINK = "https://readiness-checker-5.emergent.host/?utm_source=share";

export const ReadinessCta = ({ testId = "readiness-cta" }) => (
  <div data-testid={testId} className="flex flex-col items-start gap-2.5">
    <a
      href={LINK}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`${testId}-button`}
      className="group inline-flex items-stretch bg-[#1743B8] hover:bg-[#1E50D6] transition-colors rounded-sm shadow-lg shadow-[#1743B8]/30 overflow-hidden"
    >
      <span className="w-1.5 bg-emerald-400 group-hover:bg-emerald-300 transition-colors" aria-hidden="true" />
      <span className="flex items-center gap-2 px-6 py-3.5 text-white font-semibold text-sm sm:text-base">
        Free Loan Readiness Check
        <ArrowUpRight size={16} className="text-emerald-300" />
      </span>
    </a>
    <p className="text-xs sm:text-sm text-muted-foreground tracking-wide">
      Know your business funding readiness in 2 minutes.
    </p>
  </div>
);
